import React, { useState } from "react";
import BlogImage01 from "../../../../assets/image/image-blog-01.webp";
import BlogImage02 from "../../../../assets/image/image-blog-02.webp";
import BlogItem from "./BlogItem";
import Button from "../../../form/Button";
import useFetch from "../../../../hooks/useFetch";
import { getBlogList } from "../../../../services/BlogService";
import dayjs from "dayjs";
import { removeDuplicateFromArray, replaceOldData } from "../../../../helpers";

const SectionBlogs = () => {
  const [filters, setFilters] = useState({
    limit: 6,
    sortQuery: "-createdAt",
    page: 1,
  });

  // const BlogsData = [
  //   {
  //     _id: 1,
  //     image: BlogImage01,
  //     title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  //     date: "August 20, 2024",
  //     time: "6:16 am",
  //     postedBy: "Admin",
  //     link: "/blogs/1",
  //   },
  //   {
  //     _id: 2,
  //     image: BlogImage02,
  //     title: "Donec congue elit vehicula tempor vulputate. Donec pretium tristique magna.",
  //     date: "August 20, 2024",
  //     time: "6:16 am",
  //     postedBy: "Admin",
  //     link: "/blogs/2",
  //   },
  //   {
  //     _id: 3,
  //     image: BlogImage01,
  //     title: "Ut dapibus mauris vel tempor feugiat.",
  //     date: "August 20, 2024",
  //     time: "6:16 am",
  //     postedBy: "Admin",
  //     link: "/blogs/3",
  //   },
  //   {
  //     _id: 4,
  //     image: BlogImage02,
  //     title: "Morbi eu iaculis arcu, in tempor neque. Quisque pulvinar non mauris et dictum.",
  //     date: "August 20, 2024",
  //     time: "6:16 am",
  //     postedBy: "Admin",
  //     link: "/blogs/4",
  //   },
  //   {
  //     _id: 5,
  //     image: BlogImage01,
  //     title: "Quisque a porttitor dui. Mauris eu lacinia mauris, suscipit eleifend justo.",
  //     date: "August 20, 2024",
  //     time: "6:16 am",
  //     postedBy: "Admin",
  //     link: "/blogs/5",
  //   },
  //   {
  //     _id: 6,
  //     image: BlogImage02,
  //     title: "Nam euismod orci non blandit maximus. Pellentesque habitant morbi tristique.",
  //     date: "August 20, 2024",
  //     time: "6:16 am",
  //     postedBy: "Admin",
  //     link: "/blogs/6",
  //   },
  //   {
  //     _id: 7,
  //     image: BlogImage01,
  //     title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  //     date: "August 20, 2024",
  //     time: "6:16 am",
  //     postedBy: "Admin",
  //     link: "/blogs/7",
  //   },
  //   {
  //     _id: 8,
  //     image: BlogImage02,
  //     title: "Donec congue elit vehicula tempor vulputate. Donec pretium tristique magna.",
  //     date: "August 20, 2024",
  //     time: "6:16 am",
  //     postedBy: "Admin",
  //     link: "/blogs/8",
  //   },
  //   {
  //     _id: 9,
  //     image: BlogImage01,
  //     title: "Ut dapibus mauris vel tempor feugiat.",
  //     date: "August 20, 2024",
  //     time: "6:16 am",
  //     postedBy: "Admin",
  //     link: "/blogs/9",
  //   },
  //   {
  //     _id: 10,
  //     image: BlogImage02,
  //     title: "Morbi eu iaculis arcu, in tempor neque. Quisque pulvinar non mauris et dictum.",
  //     date: "August 20, 2024",
  //     time: "6:16 am",
  //     postedBy: "Admin",
  //     link: "/blogs/10",
  //   },
  //   {
  //     _id: 11,
  //     image: BlogImage01,
  //     title: "Quisque a porttitor dui. Mauris eu lacinia mauris, suscipit eleifend justo.",
  //     date: "August 20, 2024",
  //     time: "6:16 am",
  //     postedBy: "Admin",
  //     link: "/blogs/11",
  //   },
  //   {
  //     _id: 12,
  //     image: BlogImage02,
  //     title: "Nam euismod orci non blandit maximus. Pellentesque habitant morbi tristique.",
  //     date: "August 20, 2024",
  //     time: "6:16 am",
  //     postedBy: "Admin",
  //     link: "/blogs/12",
  //   },
  // ]

  const {
    data: BlogsData,
    error,
    isLoading,
    updateData,
    isFetching,
    refetch,
  } = useFetch({
    dependencies: ["font-blogs-list", filters],
    fetchFunction: async () => {
      const res = await getBlogList({
        type: "blog",
        ...filters,
      });
      if (res?.docs?.status === 200) {
        const blogArr = (res?.docs?.data || [])
          ?.filter((item) => item?.title)
          ?.map((item) => ({
            ...item,
            _id: item?._id,
            date: dayjs(item?.publishDate)?.format("MMMM DD, YYYY"),
            time: dayjs(item?.publishDate)?.format("hh:mm A"),
            image: item?.image?.url,
            link: `/blogs/${item?.slug || item?._id}`,
          }));

        const newArr = replaceOldData([...(BlogsData?.data || [])], blogArr);

        return {
          ...res?.docs,
          data: removeDuplicateFromArray([...newArr, ...blogArr]),
        };
      } else {
        if (BlogsData?.data?.length > 0) {
          return BlogsData;
        } else {
          return res;
        }
      }
    },
  });

  const loadMoreBlogs = (page) => {
    setFilters((pre) => ({ ...pre, page }));
  };

  return (
    <>
      <section className="relative flex w-full py-16 sm:py-24">
        <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
          {BlogsData?.data?.length > 0 && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-6 md:gap-y-16">
              {BlogsData?.data?.map((item, index) => (
                <BlogItem key={index} data={item} />
              ))}
            </div>
          )}
          {filters?.page < BlogsData?.metadata?.totalPages && (
            <div className="flex items-center justify-center mt-16">
              <Button
                buttonLabel={"Load More"}
                buttonClasses={
                  "!h-12 xl:!h-14 !rounded-full !px-6 xl:!px-10 border border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white min-w-60"
                }
                buttonLabelClasses={"!text-base xl:!text-xl"}
                buttonFunction={() => {
                  loadMoreBlogs(BlogsData?.metadata?.nextPage);
                }}
              />
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default SectionBlogs;
